

export class BranchDetailAllActiveOutput implements IBranchDetailAllActiveOutput {
    /** The auto-generated id of the tbl_branch_detail */
    branch_detail_id!: number;
    /** The company name with 255 character limit */
    company_name!: string;
    /** The branch name with 255 character limit */
    branch!: string;
    /** The city name with 255 character limit */
    city_name!: string;
    /** The state name with 255 character limit */
    state_name!: string;
    /** The country name with 255 character limit */
    country_name!: string;
    /** The contact person with 255 character limit */
    contact_person!: string;
    /** The telephone number with 13 character limit */
    telephone_number!: string;
    /** The mobile number with 10 character limit */
    mobile_number!: string;
    /** The branch code with 100 character limit */
    branch_code!: string;
    /** Manage status of branch. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IBranchDetailAllActiveOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branch_detail_id = _data["branch_detail_id"];
            this.company_name = _data["company_name"];
            this.branch = _data["branch"];
            this.city_name = _data["city_name"];
            this.state_name = _data["state_name"];
            this.country_name = _data["country_name"];
            this.contact_person = _data["contact_person"];
            this.telephone_number = _data["telephone_number"];
            this.mobile_number = _data["mobile_number"];
            this.branch_code = _data["branch_code"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): BranchDetailAllActiveOutput {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDetailAllActiveOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branch_detail_id"] = this.branch_detail_id;
        data["company_name"] = this.company_name;
        data["branch"] = this.branch;
        data["city_name"] = this.city_name;
        data["state_name"] = this.state_name;
        data["country_name"] = this.country_name;
        data["contact_person"] = this.contact_person;
        data["telephone_number"] = this.telephone_number;
        data["mobile_number"] = this.mobile_number;
        data["branch_code"] = this.branch_code;
        data["status"] = this.status;
        return data; 
    }
}

export interface IBranchDetailAllActiveOutput {
    /** The auto-generated id of the tbl_branch_detail */
    branch_detail_id: number;
    /** The company name with 255 character limit */
    company_name: string;
    /** The branch name with 255 character limit */
    branch: string;
    /** The city name with 255 character limit */
    city_name: string;
    /** The state name with 255 character limit */
    state_name: string;
    /** The country name with 255 character limit */
    country_name: string;
    /** The contact person with 255 character limit */
    contact_person: string;
    /** The telephone number with 13 character limit */
    telephone_number: string;
    /** The mobile number with 10 character limit */
    mobile_number: string;
    /** The branch code with 100 character limit */
    branch_code: string;
    /** Manage status of branch. 0 For De-active, 1 For Active */
    status: number;
}

